import { Specialty } from '@/lib/types';

import HowTo, { HowToGroupProps, HowToItemProps } from '@/components/how-to';
import { IconColor } from '@/components/icons/base-icon';
import ProfileIcon from '@/components/icons/profile-icon';
import SearchIcon from '@/components/icons/search-icon';
import SignIcon from '@/components/icons/sign-icon';

import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';
import { routes } from '@/utils/route-utils';

type BuildHowToSpecialtyItemsProps = {
  specialty?: Specialty;
};

export const buildHowToSpecialtyItems = (
  props: BuildHowToSpecialtyItemsProps
): HowToItemProps[] => [
  {
    title: 'Register to access *thousands of jobs*',
    subtitle: 'Register',
    icon: <SignIcon color={IconColor.PRIMARY} />,
    href: '/auth/register',
    iconUrl: '/images/how-to-group-icons/icon-sign.svg',
  },
  {
    title: 'Completed profiles get *faster offers*',
    subtitle: 'Complete your profile',
    icon: <ProfileIcon color={IconColor.PRIMARY} />,
    href: '/application/v2/info',
    iconUrl: '/images/how-to-group-icons/icon-profile.svg',
  },
  {
    title: 'Find your speciality and *browse open jobs*',
    subtitle: 'Search and apply',
    icon: <SearchIcon color={IconColor.PRIMARY} />,
    href: routes.jobSearch({
      discipline: props.specialty?.discipline?.apiId || undefined,
      specialty: props.specialty?.title,
    }),
    iconUrl: '/images/how-to-group-icons/icon-search.svg',
  },
];

export type HowToSpecialtyProps = Omit<HowToGroupProps, 'items'>;

export default function HowToSpecialty(props: HowToSpecialtyProps) {
  const { specialty } = useSpecialtyPageContext();

  if (!specialty) return null;
  return (
    <HowTo
      {...props}
      items={buildHowToSpecialtyItems({ ...props, specialty })}
    />
  );
}
